// Shared Map to pass price data from hook to MutationObserver.
// Keyed by objectID for InstantSearch results, and by handle for autocomplete dropdown.
const priceData = new Map();

let firstInstantSearchRender = false;

function revealInstantSearch() {
  const is = document.getElementById('algolia-shopify-instantsearch');
  if (is) {
    is.classList.add('algolia-is-ready');
    // Restore inline styles that were set to collapse the IS div
    is.style.height = '';
    is.style.overflow = '';
    is.style.padding = '';
    is.style.minHeight = '';
  }
  const ph = document.getElementById('algolia-search-placeholder');
  if (ph) {
    ph.style.opacity = '0';
    setTimeout(() => ph.remove(), 200);
  }
}

/* Instant Search Autocomplete - Hook to show search box after user types 3 characters. */
document.addEventListener('algolia.hooks.initialize', () => {
  window.algoliaShopify.hooks.registerHook('beforeAutocompleteConfigurationOptions', (config, context) => {
    if (context?.sourceId === 'articles') {
      config.queries[0].params.filters = 'blog.handle:"recipe"';
    }

    return config;
  });

  window.algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', (options) => {
    // Set placeholder text
    options.placeholder = 'Search for rugs, furniture, and more';
    // Disable full-screen detached mode so the panel drops below the search input
    options.detachedMediaQuery = 'none';
    const originalShouldPanelOpen = options.shouldPanelOpen;

    options.shouldPanelOpen = ({ state }) => {
      if ((state.query || '').trim().length < 3) {
        return false;
      }

      return originalShouldPanelOpen ? originalShouldPanelOpen({ state }) : true;
    };

    return options;
  });

  // For each hit, extract variants_min_price and variants_compare_at_price_max and store in priceData Map keyed by objectID.
  window.algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    (templateOrResult, hit, html, components) => {
      if (!firstInstantSearchRender) {
        firstInstantSearchRender = true;
        requestAnimationFrame(() => requestAnimationFrame(revealInstantSearch));
      }
      const minPrice = hit.variants_min_price;
      const compareAt = hit.variants_compare_at_price_max;
      const maxPrice = hit.variants_max_price;
      const isOnSale = compareAt && minPrice < compareAt;
      priceData.set(hit.objectID, { minPrice, maxPrice, compareAt, isOnSale });
      return typeof templateOrResult === 'function' ? templateOrResult(hit, html, components) : templateOrResult;
    },
  );

  // Populate priceData from autocomplete hits
  window.algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    (templateOrResult, templateOptions, distinct, itemLink, trackSearchAttribution) => {
      const { html, item, components } = templateOptions;
      const minPrice = item.variants_min_price;
      const compareAt = item.variants_compare_at_price_max;
      const maxPrice = item.variants_max_price;
      const isOnSale = compareAt && minPrice < compareAt;

      priceData.set(item.handle, { minPrice, maxPrice, compareAt, isOnSale });

      if (!isOnSale && minPrice === maxPrice) {
        return typeof templateOrResult === 'function'
          ? templateOrResult(templateOptions, distinct, itemLink, trackSearchAttribution)
          : templateOrResult;
      }

      const prefix = isOnSale && minPrice < maxPrice ? 'From ' : '';
      const priceHtml = isOnSale
        ? `<span class="ais-hit--price-sale">${prefix}$${minPrice.toFixed(2)}</span>
           <s class="ais-hit--price-compare">$${compareAt.toFixed(2)}</s>`
        : `<span>From $${minPrice.toFixed(2)}</span>`;

      return html`
        <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img src="${window.algoliaShopify.helpers.renderImage(item, 125).src}" alt="${item.title}" />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: 'title' })}</div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">${html([priceHtml])}</div>
              </div>
            </div>
          </div>
        </a>
      `;
    },
  );
});

// The below function is used to display search results for "query"
document.addEventListener('DOMContentLoaded', () => {
  function renameArticlesHeader(node) {
    const sources = [];

    // Check if the node itself is an .aa-Source
    if (node.classList?.contains('aa-Source')) {
      sources.push(node);
    }

    // Also check inside the node
    node.querySelectorAll?.('.aa-Source').forEach((el) => sources.push(el));

    // Now rename correctly
    sources.forEach((sourceEl) => {
      if (sourceEl.dataset.autocompleteSourceId === 'articles') {
        const header = sourceEl.querySelector('.aa-SourceHeaderTitle');
        if (header) header.textContent = 'Recipes';
      }
      if (sourceEl.dataset.autocompleteSourceId === 'pages') {
        const header = sourceEl.querySelector('.aa-SourceHeaderTitle');
        if (header) header.textContent = 'Pages';
      }
    });
  }

  const query = new URLSearchParams(window.location.search).get('q') || '';

  const autocompleteObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          renameArticlesHeader(node);

          // Patch sale price using data stored in priceData Map by using the beforeInstantSearchProductTemplate hook
          node.querySelectorAll('.ais-hit--price').forEach((priceEl) => {
            if (priceEl.dataset.processed) return;
            priceEl.dataset.processed = 'true';

            const card = priceEl.closest('.ais-hit');
            if (!card) return;

            const objectID = card.dataset.algoliaObjectid;
            const data = priceData.get(objectID);
            if (!data) return;

            if (data.isOnSale) {
              // Sale — show min price with compare-at struck through
              // Add "From" prefix only if there is a price range across variants
              const prefix = data.minPrice < data.maxPrice ? 'From ' : '';
              priceEl.innerHTML = `
              <span class="ais-hit--price-sale">${prefix}$${data.minPrice.toFixed(2)}</span>
              <s class="ais-hit--price-compare">$${data.compareAt.toFixed(2)}</s>
            `;
            } else if (data.minPrice < data.maxPrice) {
              // Price range — show "From" with min price, no strikethrough
              priceEl.innerHTML = `<span>From $${data.minPrice.toFixed(2)}</span>`;
            }
          });

          if (query.trim()) {
            const aisPage = node.matches?.('.ais-page') ? node : node.querySelector?.('.ais-page');
            if (aisPage && !document.querySelector('.custom-search-title')) {
              const customTitle = document.createElement('div');
              customTitle.className = 'custom-search-title';
              customTitle.textContent = `Search results for "${query.trim()}"`;
              aisPage.insertBefore(customTitle, aisPage.firstChild);
            }
          }
        }
      });
    });
  });

  autocompleteObserver.observe(document.body, { childList: true, subtree: true });

  // Algolia only initializes on the first form[action="/search"] (desktop).
  // On mobile, <predictive-search> runs Shopify's native search instead.
  // This moves the Algolia widget into the mobile modal when it opens,
  // and back to desktop when it closes. CSS hides <predictive-search> automatically.
  const [desktop, mobile] = document.querySelectorAll('details-modal.header__search');

  if (desktop && mobile) {
    const mobileDetails = mobile.querySelector('details');
    const mobileContent = mobile.querySelector('.search-modal__content');
    const desktopContent = desktop.querySelector('.search-modal__content');

    function syncAlgolia() {
      const algolia = document.querySelector('.aa-Autocomplete');
      if (!algolia) return;

      const isOpen = mobileDetails.hasAttribute('open');
      const target = isOpen ? mobileContent : desktopContent;

      if (target && algolia.parentElement !== target) {
        target.prepend(algolia);
        if (isOpen) setTimeout(() => mobileContent.querySelector('.aa-Input')?.focus(), 100);
      }
    }

    // Move widget when mobile modal opens or closes
    new MutationObserver(syncAlgolia).observe(mobileDetails, { attributes: true, attributeFilter: ['open'] });

    // Move widget whenever .aa-Autocomplete is added (or re-added) while mobile is open.
    // Handles slow Algolia script load, widget recreation, and any ordering of events.
    new MutationObserver((mutations) => {
      if (!mobileDetails.hasAttribute('open')) return;
      for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.classList.contains('aa-Autocomplete') || node.querySelector?.('.aa-Autocomplete')) {
            syncAlgolia();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // On mobile, push the panel below the search form so the input stays visible.
  // Uses setProperty with 'important' so it wins over any CSS !important rule.
  function fixMobilePanelTop() {
    if (window.innerWidth >= 1024) return;
    const form = document.querySelector('.aa-Autocomplete .aa-Form');
    const panel = document.querySelector('.aa-Panel');
    if (!form || !panel) return;
    const h = form.offsetHeight;
    if (h > 0) {
      if (document.documentElement.classList.contains('webview')) {
        // In WebView, the autocomplete widget is moved outside the header.
        // Position the panel directly below the form (no gap).
        // Panel is position:absolute with margin-top from CSS; override both.
        var formRect = form.getBoundingClientRect();
        panel.style.setProperty('margin-top', '0', 'important');
        panel.style.setProperty('top', Math.round(formRect.bottom) + 'px', 'important');
      } else {
        panel.style.setProperty('top', '100px', 'important');
      }
    }
  }

  new MutationObserver(fixMobilePanelTop).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', fixMobilePanelTop);

  // ─── WebView: Move Algolia autocomplete outside the hidden header ─────
  // The header is hidden in WebView (disable-on-webview-only), but the
  // Algolia autocomplete widget is mounted inside the header search form.
  // We move the .aa-Autocomplete widget to a visible container between
  // the header and <main> so the user gets autocomplete on /search only.
  if (document.documentElement.classList.contains('webview') && window.location.pathname === '/search') {
    function moveAutocompleteToWebView() {
      const widget = document.querySelector('.aa-Autocomplete');
      if (!widget) return false;

      // Already moved
      if (widget.closest('.webview-autocomplete-container')) return false;

      // Create a visible container outside the header
      const container = document.createElement('div');
      container.className = 'webview-autocomplete-container';
      container.style.cssText = 'padding: 0.8rem 1.6rem; background: #fff;';

      // Move the widget (preserves event listeners)
      container.appendChild(widget);

      // Insert before #MainContent (survives InstantSearch DOM replacement)
      const main = document.getElementById('MainContent');
      if (main) {
        main.parentNode.insertBefore(container, main);
      } else {
        document.body.insertBefore(container, document.body.firstChild);
      }

      // Focus the input
      setTimeout(() => {
        const input = widget.querySelector('input');
        if (input) input.focus();
      }, 200);

      console.log('[WebView] Moved Algolia autocomplete outside header');
      return true;
    }

    // Try immediately, then watch for widget to appear
    if (!moveAutocompleteToWebView()) {
      new MutationObserver(() => moveAutocompleteToWebView()).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    // ─── WebView: Hide InstantSearch results when no query ─────────────
    // When the app navigates to /search without ?q=, Algolia InstantSearch
    // searches with an empty string and returns all products. We hide the
    // results container until the user types and submits a query (which
    // navigates to /search?q=... and reloads the page with results).
    const urlQuery = new URLSearchParams(window.location.search).get('q') || '';
    if (!urlQuery.trim()) {
      function hideInstantSearch() {
        const is = document.getElementById('algolia-shopify-instantsearch');
        if (!is) return false;
        if (is.style.display === 'none') return true;
        is.style.display = 'none';
        return true;
      }
      if (!hideInstantSearch()) {
        const observer = new MutationObserver(() => {
          if (hideInstantSearch()) observer.disconnect();
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    }
  }

  // Start - add the CSS through js for search page
  if (window.location.pathname === '/search') {
    // Safety net: if Algolia errors or takes too long, reveal after 4s.
    setTimeout(revealInstantSearch, 4000);

    if (query.trim()) {
      const showLoader = () => {
        if (document.getElementById('algolia-search-placeholder')) return true;
        const is = document.getElementById('algolia-shopify-instantsearch');
        if (!is) return false;

        // Collapse the IS div so it takes no space
        is.style.height = '0';
        is.style.overflow = 'hidden';
        is.style.padding = '0';
        is.style.minHeight = '0';

        // Insert loading section immediately before IS div.
        // display:flex !important beats any CSS display:none on this element.
        const ph = document.createElement('div');
        ph.id = 'algolia-search-placeholder';
        ph.style.cssText =
          'display:flex !important;flex-direction:column;align-items:center;justify-content:center;gap:1.6rem;min-height:50vh;background:#f5f5f5;transition:opacity 0.2s ease;';
        const loaderTemplate = document.getElementById('algolia-loader-template');
        ph.appendChild(loaderTemplate.content.cloneNode(true));
        is.parentNode.insertBefore(ph, is);
        return true;
      };

      if (!showLoader()) {
        const isWatcher = new MutationObserver(() => {
          if (showLoader()) isWatcher.disconnect();
        });
        isWatcher.observe(document.body, { childList: true, subtree: true });
      }

      // Overlay dismissal for no-results: separate from the no-results UI logic.
      // Fires when Algolia renders an empty state inside the IS div.
      // Results case is handled by beforeInstantSearchProductTemplate.
      const overlayDismissWatcher = new MutationObserver(() => {
        if (firstInstantSearchRender) {
          overlayDismissWatcher.disconnect();
          return;
        }
        const is = document.getElementById('algolia-shopify-instantsearch');
        if (!is) return;
        if (is.querySelector('.ais-Hits--empty') || is.querySelector('.ais-hit-empty')) {
          overlayDismissWatcher.disconnect();
          requestAnimationFrame(() => requestAnimationFrame(revealInstantSearch));
        }
      });
      overlayDismissWatcher.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    const addAlgoliaSearchPageClass = () => {
      const panel = document.querySelector('.aa-Panel');
      if (panel && !panel.classList.contains('algolia-search-page')) {
        panel.classList.add('algolia-search-page');
      }
    };
    addAlgoliaSearchPageClass();

    const observer = new MutationObserver(() => {
      addAlgoliaSearchPageClass();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // No-results UI: separate concern from overlay dismissal.
    // Toggles .ais-page--no-results and shows/hides the custom message.
    const updateNoResultsState = () => {
      const page = document.querySelector('.ais-page');
      if (!page) return;
      const isEmpty = !!page.querySelector('.ais-Hits--empty') || !!page.querySelector('.ais-hit-empty');
      page.classList.toggle('ais-page--no-results', isEmpty);

      let msg = page.querySelector('.custom-no-results-message');
      if (isEmpty && !msg) {
        msg = document.createElement('div');
        msg.className = 'custom-no-results-message';
        msg.innerHTML =
          '<p class="custom-no-results-title">No results found</p>' +
          '<p class="custom-no-results-subtitle">Check the spelling or use a different word or phrase.</p>';
        const title = page.querySelector('.custom-search-title');
        page.insertBefore(msg, title ? title.nextSibling : page.firstChild);
      } else if (!isEmpty && msg) {
        msg.remove();
      }
    };

    new MutationObserver(updateNoResultsState).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }
  // End - add the CSS through js for search page
});
